import { render, staticRenderFns } from "./GenericList.vue?vue&type=template&id=8a2cc5e4&scoped=true&"
import script from "./GenericList.vue?vue&type=script&lang=js&"
export * from "./GenericList.vue?vue&type=script&lang=js&"
import style0 from "./GenericList.vue?vue&type=style&index=0&id=8a2cc5e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2cc5e4",
  null
  
)

export default component.exports